export default {
    optInReactClient: {
        datapoint: {
            name: 'optInReactClient',
        },
    },
    cleanupOptInCallout: {
        datapoint: {
            name: 'cleanupOptInCallout',
            customData: (lightningIdSource: number) => [lightningIdSource],
        },
    },
};
